import mod_analyse from "@/store/mods/clinique/analyses.js"
import mod_prestation from "@/store/mods/clinique/prestations.js"
import TypeFacturationChoix from '@/components/type-facturation-choix'
import ChoixPrestations from '@/components/choix-prestations'

export default {
    name: 'm-analyse',
    components: { ChoixPrestations, TypeFacturationChoix },
    props: {
        user_id: Number,
        info_patient: Object,
        info_caissier: Object,
        refresh_state: Number,
        is_proforma: Boolean,
        proforma_id: Number,
        can_add_differential_computing: Object,
        format_ref_facture: String,
        selected_slug: String,
        patient_insurance_info: Object
    },
    data() {
        return {
            one_is_checked: [],
            save_loading: false,
            choice_is_empty: false,
            is_error: false,
            permission_is_denied: false,

            filter_analyse: '',
            filtered_analyses: [],
            selected_prestations: [],

            all_checked: false,
			each_cat_is_checked: [],
            text_grey: [],
            anl_is_loading: true,
            anl_is_empty: false,

            categoriesAnalyses: []
            , onglet_analyse: 'individuelles', liste_bilans: [], bilans_charges: false, bilans_loading: false,

            // Type de facturation (normal / urgence), remis à normal à chaque ouverture (15/10/2026)
            type_facturation: 'normal'
        }
    },

    watch: {
        onglet_analyse(onglet) {
            if (onglet === 'bilans' && !this.bilans_charges) this.fetchBilans()
        },
        filter_analyse() {
            this.filterAnalyse()
        },

        type_facturation() {
            this.retirerSansPrix()
        },

        refresh_state() {
            if (this.selected_slug == 'analyse') {
                this.type_facturation = 'normal'
                this.$store.dispatch('getTypesFacturationPrestation')
                this.fetchAnalyse()
            }
        }
    },

    computed: {
        types_facturation_prestation() {
            return this.$store.getters['types_facturation_prestation']
        },

        champ_prix() {
            return (this.type_facturation === 'urgence') ? 'prix_urgence' : 'prix'
        },
        
    },

    mounted() {
        
    },

    methods: {
        fetchBilans() {
            this.bilans_loading = true
            return mod_prestation.getListeBilanSante().then(liste => {
                this.liste_bilans = Array.isArray(liste) ? liste : []
                this.bilans_charges = true
            }).catch(() => { this.warningToast('Impossible de charger les bilans.') }).finally(() => {
                this.bilans_loading = false
            })
        },
        fetchAnalyse() {
            this.anl_is_loading = true
            mod_analyse.getCategoriesAnalyse().then((categorie_analyses) => {
                this.categoriesAnalyses = categorie_analyses
                if (this.categoriesAnalyses.length == 0) {
                    this.anl_is_empty = true
                } else {
                    this.anl_is_empty = false
                    this.filtered_analyses = this.categoriesAnalyses
                }

                this.anl_is_loading = false
            }).catch(() => {
                this.anl_is_loading = false
                this.is_error = true
            })
        },

        onPriceUndefined(analyse) {
            if (this.type_facturation === 'urgence') {
                this.warningToast("Tarif urgence non configuré pour " + ((analyse && analyse.nom) ? analyse.nom : "cette analyse"))
                return
            }
            this.warningToast("Le prix de cette analyse n'a pas été défini !")
        },

        /**
         * Prix de l'analyse pour le type de facturation choisi (prix urgence NULL = non configuré)
         */
        prixSelonType(analyse) {
            return Number((this.type_facturation === 'urgence') ? analyse.prix_urgence : analyse.prix)
        },

        /**
         * Changement de type : décocher les analyses sans prix pour ce type
         */
        retirerSansPrix() {
            const sans_prix = this.one_is_checked.filter(analyse => !(this.prixSelonType(analyse) > 0))
            if (sans_prix.length == 0) {
                return
            }
            this.one_is_checked = this.one_is_checked.filter(analyse => this.prixSelonType(analyse) > 0)

            const motif = (this.type_facturation === 'urgence') ? 'Tarif urgence non configuré' : 'Prix non configuré'
            this.warningToast(motif + " pour " + sans_prix.map(analyse => analyse.nom).join(', ') + " (décochée(s))")
        },

        estAnalyseSelectionnee(id) {
            return this.one_is_checked.some(item => Number(item.id) === Number(id))
        },

        submit() {
            if (this.one_is_checked.length == 0) {
                this.choice_is_empty = true
                return;
            }
            this.one_is_checked = this.setPrestationUID(this.one_is_checked)

            let data = {
                user_id: this.user_id,
                patient_id: this.info_patient.id,
                prestations: this.one_is_checked.map(analyse => Object.assign({}, analyse, { type_facturation: this.type_facturation })),
                type_prestation: 'Analyses',
                data_type: 'analyse',
                proforma_id: this.proforma_id,
                is_proforma: this.is_proforma,
                can_add_differential_computing: this.can_add_differential_computing.response,
                can_set_pac: this.can_set_pac,
                info_caissier: this.info_caissier,
                info_patient: {
                    nom_patient: this.info_patient.nom,
                    sexe: this.formatSexeMetier(this.info_patient.sexe),
                    telephone: this.info_patient.telephone_mobile,
                    num_dossier: this.info_patient.num_dossier,
                    age: this.info_patient.age
                },
                format_ref_facture: this.format_ref_facture
            }

            this.save_loading = true
            mod_prestation.getTarifPrestation(data).then((response) => {
                // Urgence sans prix urgence configuré : jamais facturée, ni au prix normal
                const urgences_absentes = (response.prestations || []).filter(prestation => prestation.tarif_urgence_absent == 1)
                if (urgences_absentes.length > 0) {
                    this.save_loading = false
                    this.dangerToast("Tarif urgence non configuré pour " + urgences_absentes.map(prestation => prestation.libelle).join(', '))
                    return
                }

                data = Object.assign(data, response)
                data.duree_forfait_hospi_est_expire = this.patient_insurance_info.duree_forfait_hospi_est_expire

                this.$store.dispatch('saveVentePrestation', data).then((response) => {
                    if (response.success) {
                        this.successToast('Ajout effectué avec succès')

                        this.$emit('emitPrestation', response.fpro_id)

                        this.one_is_checked = []
                        this.$refs.fpro_analyse.click()

                        if (response.fpro_id > 0) {
                            this.$router.push({ path: '/ventes/facture-proforma/'+response.fpro_id })
                        }
                    } else {
                        this.$refs.fpro_analyse.click()
                        this.dangerToast(response.message)
                    }

                    this.save_loading = false
                }).catch((error) => {
                    this.save_loading = false
                    this.$refs.fpro_analyse.click()
                    // Refus de la caisse (ex. 422 : tarif urgence non configuré) : afficher son message
                    this.dangerToast((error && error.response && error.response.data && error.response.data.message) || 'Une erreur est survenue lors de l\'enregistrement. Veuillez réessayer plus tard.')
                })
            }).catch(() => {
                this.save_loading = false
                this.$refs.fpro_analyse.click()
                this.dangerToast('Une erreur est survenue lors du calcul des tarifs. Veuillez réessayer plus tard.')
            })
        },

        filterAnalyse() {
            this.filtered_analyses = [];

            if (this.filter_analyse == '') {
                this.filtered_analyses = this.categoriesAnalyses
            } else {
                this.categoriesAnalyses.forEach((categorie_analyse) => {
                    categorie_analyse.analyses.forEach(analyse => {
                        let cleaned_analyse = this.removeAccents(analyse.nom)
                        let cleaned_filter = this.removeAccents(this.filter_analyse)
    
                        if (cleaned_analyse.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                            this.filtered_analyses.push(analyse)
                        }
                    });
                });
                
            }
        },

        /**
		 * Sélectionner / Déselectionner une catégorie de médicament
		 */
		touteCategorie(index) {
			let is_checked = this.each_cat_is_checked.includes(index)

            this.toggleCategorieChecked(is_checked, index)
		},

        toggleCategorieChecked(is_checked, index) {
            this.categoriesAnalyses.forEach((categorie_analyse) => {
                if (categorie_analyse.id == index) {
                    let one_price_is_undefined = false

                    categorie_analyse.analyses.forEach((_data) => {
                        const tmp_analyse = {
                            id: _data.id,
                            nom: _data.nom,
                            prix: _data.prix,
                            prix_urgence: _data.prix_urgence
                        }
                        if (is_checked) {
                            if (!(this.prixSelonType(_data) > 0)) {
                                one_price_is_undefined = true
                                return
                            }
                            if (!this.estAnalyseSelectionnee(_data.id)) this.one_is_checked.push(tmp_analyse)
                        } else {
                            this.one_is_checked = this.one_is_checked.filter(item => item.id != tmp_analyse.id)
                        }
                    })

                    if (one_price_is_undefined) {
                        this.warningToast("Le prix d'une ou plusieurs analyses (décochée(s) dans la liste) n'a pas été défini !")
                    }
                }
            });
            
            this.all_checked = is_checked
        },
    }
}


